module.exports = "https://99designs-start-assets.imgix.net/js/1069c31316e8eea1f191aef1ff543cbf.png";